<template>
  <div class="booth-list">
    <div class="list-table__title">Undefined Task List</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="unfinishedTasks"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(state)="unfinishedTask">
        <div class="mb-1">{{ unfinishedTask.item.isLate ? 'Late' : 'On Time' }}</div>
        <div>{{ unfinishedTask.item.isSend ? 'Submitted' : 'Not Submitted' }}</div>
      </template>

      <template #cell(tutor)="unfinishedTask">
        <router-link :to="{name:'TutorDetail' , params: { id: unfinishedTask.item.tutor.tutorId }}">
          {{ unfinishedTask.item.tutor.tutorId }} {{ unfinishedTask.item.tutor.name }}
        </router-link>
      </template>

      <template #cell(students)="unfinishedTask">
        <router-link
          v-for="student in unfinishedTask.item.students"
          :key="student.id"
          :to="{name:'StudentDetail' , params: { id: student.id }}"
        >
          {{ student.name }}
        </router-link>
      </template>

      <template #cell(detail)="unfinishedTask">
        <div>
          <b-button
            v-if="unfinishedTask.item.type === 'classRecord'
            && unfinishedTask.item.lesson.fiscalyear <= 2023"
            pill
            class="mw-0"
            variant="outline-secondary"
            :to="{name: 'OldLMSData' }"
            >
            Detail
          </b-button>
          <b-button
            v-else
            pill
            class="mw-0"
            variant="outline-secondary"
            :to="{name: 'UnfinishedTaskDetail', params: { deadlineId: unfinishedTask.item.id }}"
          >
            Detail
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Moment } from 'moment'
import _ from 'lodash'
import { Level } from '@/store/master/types';

export default {
  data() {
    return {
      fields: [
        {
          key: 'state',
          label: 'Type',
        },
        {
          key: 'type',
          label: 'Task Type',
        },
        {
          key: 'expired',
          label: 'Deadline',
          formatter: (expired: Moment): string => expired.format('YYYY/MM/DD HH:mm:ss'),
        },
        {
          key: 'lesson.datetime',
          label: 'Lesson Date',
          formatter: (datetime: Moment): string => datetime.format('YYYY/MM/DD'),
        },
        {
          key: 'tutor',
          label: 'Tutor ID/Tutor',
        },
        {
          key: 'Students',
          label: 'Student',
        },
        {
          key: 'lesson.period',
          label: 'Period',
        },
        {
          key: 'lesson.level',
          label: 'Level',
          formatter: (level: Level) => level?.code,
        },
        {
          key: 'detail',
          label: 'Detail',
        },
      ],
    };
  },

  props: {
    unfinishedTasks: Array,
  },
};
</script>

<style>
.booth-list .list-table .list-table__head {
  font-size: .8rem;
}

.booth-list .list-table .list-table__body td {
  font-size: .8rem;
}
</style>

<style scoped>
.mw-0 {
  min-width: 0;
  font-size: .8rem;
}

.detail-button {
  display: block;
  text-decoration: none;
  color: #000;
  padding: 10px;
  border: 2px solid #AAAFB6;
  border-radius: 20px;
  cursor: pointer;
};

.detail-button:hover {
  background: #000;
};
</style>
